(function () {
  'use strict';
  if (window.__shoppablePlpImageBound) return;
  window.__shoppablePlpImageBound = true;

  function closeOpenWidgets(except) {
    document.querySelectorAll('.shoppable-plp-image__widget.is-open').forEach(function (w) {
      if (w !== except) w.classList.remove('is-open');
    });
  }

  // Delegated, so it works for tiles added later (filter re-renders, load more, theme editor).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-shoppable-toggle]');
    if (btn) {
      var widget = btn.closest('.shoppable-plp-image__widget');
      if (!widget) return;
      e.preventDefault();
      closeOpenWidgets(widget);
      widget.classList.toggle('is-open');
      return;
    }
    // Click anywhere outside an open panel closes it.
    document.querySelectorAll('.shoppable-plp-image__widget.is-open').forEach(function (w) {
      if (!w.contains(e.target)) w.classList.remove('is-open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOpenWidgets(null);
  });
})();
